import React, { useState, useEffect, useRef } from "react";
import { Chessboard } from "react-chessboard";
import { HEADER_HEIGHT } from '../config/Constants';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import {
  View,
  Text,
  Dimensions
} from 'react-native';

export default function Tuto(props) {
  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });
  const navigate = useNavigate();

  const [step, setStep] = useState(1);
  const [position, setPosition] = useState('rnbqkbnr/ppppppp1/8/7p/6P1/8/PPPPPP1P/RNBQKBNR w KQkq h6 0 2');
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [showSparta, setShowSparta] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const onDrop = (sourceSquare, targetSquare, piece) => {
    if (step === 1) {
      if (sourceSquare === 'g4' && targetSquare === 'h5') {
        setShowSparta(true);
        if (videoRef.current) {
          videoRef.current.play().catch(e => console.log(e));
        }
        setStep(2);
        setPosition('rnb1kbnr/ppp2pp1/3p4/7P/6Q1/1q2P3/PPP2P1P/RNB1KBNR w KQkq - 0 1');
        return true;
      } else {
        setErrorMsg("Wrong move! Take the pawn on h5.");
        return false;
      }
    } else if (step === 2) {
      if (sourceSquare === 'g4' && targetSquare === 'c8') {
        setStep(3);
        setPosition('rnb1k2r/ppp2ppp/8/5b2/4q3/P7/1PP1PPP1/2K5 w KQkq - 0 1');
        return true;
      } else {
        setErrorMsg("Wrong move! Find the checkmate on c8.");
        return false;
      }
    } else if (step === 3) {
      if (sourceSquare === 'c1' && targetSquare === 'b1') {
         setSuccessMsg("Congratulations! You are ready to play now.");
         return true;
      } else {
         setErrorMsg("Wrong move! Position the king so that it prevents the queen from pushing your pawn and doing checkmate");
         return false;
      }
    }
    return false;
  }

  var smallWidth = windowDimensions.width <= 480;
  var prct = smallWidth ? 0.92 : 0.8;
  var minSize = Math.min(windowDimensions.width, windowDimensions.height - HEADER_HEIGHT - 80) * prct;

  const getCustomSquareStyles = () => {
    let styles = {};
    if (step === 1) {
      const files = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h'];
      const ranks = ['1', '2', '3', '4', '5', '6', '7', '8'];
      
      for (let i = 0; i < files.length; i++) {
        for (let j = 0; j < ranks.length; j++) {
          const file = files[i];
          const rank = ranks[j];
          if (file === 'a' || file === 'h' || rank === '1' || rank === '8') {
            const isDark = (i + j) % 2 === 0;
            styles[`${file}${rank}`] = { backgroundColor: isDark ? '#B51C00' : '#F54927' };
          }
        }
      }
    }
    
    if (step === 1 || step === 2) {
      styles['g4'] = { ...styles['g4'], backgroundColor: "rgba(255, 255, 0, 0.4)", borderRadius: "4px", boxShadow: "inset 0 0 1px 4px rgba(255, 255, 0, 0.8)" };
    } else if (step === 3) {
      styles['c1'] = { ...styles['c1'], backgroundColor: "rgba(255, 255, 0, 0.4)", borderRadius: "4px", boxShadow: "inset 0 0 1px 4px rgba(255, 255, 0, 0.8)" };
    }
    
    return styles;
  }

  let message = "";
  if (step === 1) {
    message = "Beware the edges! Pieces on the border can be pushed off the board. Inland pieces are safe, though kings still capture normally.\nTry pushing the pawn on h5 off. Don't worry, your pawn is safe.";
  } else if (step === 2) {
    message = "Just like in regular chess, your ultimate goal in Sumochess is to checkmate the enemy king! Go ahead, find the winning move.";
  } else if (step === 3) {
    message = "This puzzle is tricky! You can only push one piece at a time. Use this to your advantage and move your king to prevent checkmate.";
  }

  return (
    <View style={{ alignItems: "center", marginTop: 20 }}>
      <Text style={{color:'#fff', marginBottom:20, maxWidth: Math.max(minSize, 400), textAlign: 'center', fontSize: 18}}>
        {message}
      </Text>
      
      <View style={{ width: minSize + 'px' }}>
        <Chessboard
          style={{
            width: minSize + 'px',
            height: minSize + 'px'
          }}
          id="TutoBoard"
          position={position}
          onPieceDrop={onDrop}
          isDraggablePiece={(piece) => true}
          customSquareStyles={getCustomSquareStyles()}
          customBoardStyle={{
            boxShadow: "0 5px 25px rgba(0, 0, 0, 0.5)",
            borderRadius: "6px",
          }}
          customDropSquareStyle={{ boxShadow: "inset 0 0 1px 4px rgba(255, 255, 0, 0.5)" }}
          customLightSquareStyle={{ backgroundColor: "#D1A038" }}
          customDarkSquareStyle={{ backgroundColor: "#A1291F" }}
          boardOrientation={'white'}
        />
      </View>
      
      <Modal show={errorMsg !== "" || successMsg !== ""} onHide={() => {
          if (successMsg !== "") {
            navigate('/');
          } else {
            setErrorMsg("");
          }
        }} centered contentClassName="bg-dark text-white">
        <Modal.Body style={{ textAlign: 'center', padding: '30px' }}>
          <h5 style={{ fontWeight: 'normal', letterSpacing: 1 }}>{errorMsg || successMsg}</h5>
          <Button variant="warning" style={{ marginTop: '20px', paddingLeft: '30px', paddingRight: '30px' }} onClick={() => {
            if (successMsg !== "") {
              navigate('/');
            } else {
              setErrorMsg("");
            }
          }}>
            OK
          </Button>
        </Modal.Body>
      </Modal>

      <video
        ref={videoRef}
        preload="auto"
        onEnded={() => setShowSparta(false)}
        style={{
          display: showSparta ? 'block' : 'none',
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          zIndex: 9999,
          objectFit: 'contain',
          backgroundColor: 'rgba(0,0,0,0.9)'
        }}
      >
        <source src="/imgs/sparta.mp4" type="video/mp4" />
      </video>
    </View>
  );
}
